// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__PGh22","sheet":"styles_sheet__p038s"};